module.exports = __webpack_public_path__ + "img/white.1b94f618.webp";